import { render, staticRenderFns } from "./ChapterMoveItem.vue?vue&type=template&id=22454cb4&scoped=true&"
import script from "./ChapterMoveItem.vue?vue&type=script&lang=ts&"
export * from "./ChapterMoveItem.vue?vue&type=script&lang=ts&"
import style0 from "./ChapterMoveItem.vue?vue&type=style&index=0&id=22454cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22454cb4",
  null
  
)

export default component.exports